<template>
  <div>
    <PCNavbar selectIndex="1" :currentIndex="currentIndex" :section3ScrollTop="section3ScrollPosition" pageType="home"/>
    <!-- <MobileNavBar :currentActive="1" /> -->
    <div class="fullpage-container" @wheel="handleWheel">
      <div 
        class="fullpage-wrapper" 
        :style="{ transform: `translateY(-${currentIndex * 100}vh)` }"
      >
        <!-- 第一屏 -->
        <section class="fullpage-section section-1" @click="closeChat">
          <div class="section-content_1">
            <img class="topBack" src="@/assets/img/home/homeTopBack.png" alt="">
            <img class="topBT" src="@/assets/img/home/top_b.png" alt="">
            <!-- <img class="topBTWorld" src="@/assets/img/home/top_b_world.png" alt=""> -->
            <img class="topBigCenter" 
              :class="{'chat-expanded': isChatExpanded}" 
              src="@/assets/img/home/bigCenter.png" 
              alt=""
              @mouseenter="showTips = true"
              @mouseleave="showTips = false"
            >
            <div class="text_1_view"></div>
            <div class="tips_1" v-show="showTips && !isChatExpanded">
              <div class="tips_1_text"><span>蓝脚鲣鸟</span>海洋的“碳中和小能手”。它的鸟粪喂肥了海岛，潜水捕食帮浮游植物“打工”光合固碳。更关键的是，它是气候变化的“报警器”一旦它饿肚子停孵蛋，就是在警告我们：大海“发烧”了</div>
            </div>
            <!-- <div class="tips_2" v-show="showTips && !isChatExpanded">
              <div class="tips_2_text">这种高效的<span>生态循环</span>本身即是自然碳汇系统的一部分，对维持海洋生态平衡、间接助力碳中和具有独特意义</div>
            </div> -->
            <div class="section-1_bottom">
              <div class="bottom_left_view">
                <div class="bottom_left_view_title">用AI重新定义碳中和之路</div>
                <div class="bottom_left_view_text">全球首个碳中和领域专业大模型(闭源)</div>
                <div class="bottom_left_view_text">全球首个全生命周期碳管理AI Agent产品</div>
                <!-- <div class="bottom_left_view_text">提供颠覆性的碳管理解决方案</div>
                <div class="bottom_left_view_text">引领着行业正式进入AI时代</div> -->
                <!-- <img class="bottom_left_view_img" src="@/assets/img/home/bottom_left_view_img.png" alt=""> -->
              </div>
              <!-- <div class="bottom_chat" :class="{'bottom_chat_expanded': isChatExpanded}" :key="'bottom_chat_' + isChatExpanded">
                <div class="bottom_chat_view" :class="{'bottom_chat_view_expanded': isChatExpanded}">
                  <div class="bottom_chat_bar">
                    <div class="bottom_chat_bar_l">
                      <img class="bottom_chat_bar_l_img" src="@/assets/img/home/bottom_chat_bar_l_img.png" alt="">
                    </div>
                    <div class="bottom_chat_bar_r">碳芯，首个双碳垂类大模型</div>
                  </div>
                  <div class="bottom_chat_view_t">
                    <div class="bottom_chat_view_t_chat">
                      <div 
                        class="chat-messages-container" 
                        ref="chatMessagesContainer"
                        @wheel="handleChatScroll"
                      >
                        <div 
                          v-for="(message, index) in messages" 
                          :key="index"
                          :class="['chat-message', message.isUser ? 'user-message' : 'bot-message']"
                        >
                          <div v-if="message.isUser" class="message-icons">
                            <div class="message-content" v-html="message.displayText || message.content"></div>
                            <img class="message-icon message-icon-after" src="@/assets/img/home/user-icon.png" alt="用户">
                          </div>
                          
                          <div v-else class="message-icons">
                            <img class="message-icon message-icon-before" src="@/assets/img/home/ai-icon.png" alt="AI">
                            <template v-if="message.isLoading">
                              <div>正在生成中...</div>
                            </template>
                            <template v-else>
                              <div class="message-content" v-html="message.displayText || message.content"></div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bottom_chat_view_b">
                    <el-input 
                      type="textarea"
                      class="el-textarea_view"
                      placeholder="为每一克碳排放发现更优解"
                      v-model="newMessage"
                      @keydown.native="handleKeyDown"
                      @keyup.native="handleKeyUp"
                      @focus="expandChat"
                    >
                    </el-input>
                    <div class="bottom_chat_send" :class="{'wecome_container_content_send_disabled': !newMessage}" @click="sendMessage">
                        <img class="bottom_chat_send_icon" src="@/assets/img/home/send.png" alt="send"/>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="bottom_right_view">
                <img class="bottom_right_view_img" src="@/assets/img/home/bottom_right_view_img.png" alt="">
                <div class="bottom_right_view_view">
                  <el-carousel :interval="3000" indicator-position="outside" arrow="never" trigger="click">
                    <el-carousel-item v-for="(item,index) in carouselData" :key="index">
                      <div class="bottom_right_view_view_v">
                        <div class="bottom_right_view_view_v_title" v-if="index != 1">{{ item.title }}</div>
                        <div class="bottom_right_view_view_v_title" v-else>{{ item.title }}</div>
                        <div class="bottom_right_view_view_v_title_other">{{ item.subtitle }}</div>
                        <div class="bottom_right_view_view_v_info">
                          <div v-for="(info, infoIndex) in item.infoList" :key="infoIndex">{{ info }}</div>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <!-- 第三屏 -->
        <section class="fullpage-section section-3">
          <div class="section-3-container" :class="{ 'scrollable': currentIndex === 1 && isSection3MiddleAnimationDone }">
            <div class="section-3-content">
              <div class="section-3-content_middle">
                <div 
                  v-for="(word, index) in carbonWords" 
                  :key="index"
                  class="carbon-word"
                  :style="getWordStyle(index)"
                >
                  {{ word }}
                </div>
                <div class="carbonWordText">{{ carbonWordText }}</div>
                <div v-if="showText">
                  <div class="carbonWordText_1">碳芯，为您打开双碳世界的方向</div>
                  <div class="carbonWordText_2" @click="gotoWeb">了解详情→</div>
                </div>
              </div>
              <div class="section-3-content_bottom" :class="{ 'visible': isSection3MiddleAnimationDone }">
                <!-- <img class="img1" src="@/assets/img/home/section-3-content_bottom_img1.png" alt=""> -->
                <div class="bottom_view">
                  <img class="img2" src="@/assets/img/home/section-3-content_bottom_img2.png" alt="">
                  <div class="bottom_view_title">为每一克碳寻找最优解</div>
                  <div class="bottom_view_subtitle">碳知，以 AI 重构双碳工作的时代级产品</div>
                  <div class="bottom_view_button" @click="gotoWeb">了解详情→</div>
                </div>
                <!-- <div class="bottom_view_gsap"></div> -->
                <div class="bottom_view mt-175">
                  <div class="bottom_view_title">不止于此，不至于己</div>
                  <div class="bottom_view_subtitle">碳行，用AI赋能可持续发展</div>
                  <div class="bottom_view_button" @click="gotoWeb">了解详情→</div>
                </div>
                <div class="special_view" @wheel="handleSpecialViewScroll">
                  <div class="photo-carousel">
                    <div 
                      v-for="photo in visiblePhotos" 
                      :key="photo.slotIndex"
                      class="photo-item"
                      :class="getPhotoClass(photo.slotIndex)"
                      :style="getPhotoStyle(photo.slotIndex)"
                      @click="selectPhoto(photo.id)"
                    >
                      <img :src="photo.src">
                    </div>
                  </div>
                  <div class="photo-carousel_info" v-if="centerPhoto">
                    <div class="photo-carousel_info-title">{{ centerPhoto.title }}</div>
                    <div class="photo-carousel_info-content">{{ centerPhoto.content }}</div>
                  </div>
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import "highlight.js/styles/atom-one-dark.css";
import katex from "katex";
import mkatex from "markdown-it-katex";
import "katex/dist/katex.min.css";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import Footer from '@/components/footer/index'
import {
  guestLogin
} from "@/api";

import http from "@/utils/http";
// 配置 markdown-it
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  breaks: true,
  highlight: function (str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return `<div class="code-block">
                  <pre class="hljs"><code class="language-${lang}">${
          hljs.highlight(str, { language: lang, ignoreIllegals: true }).value
        }</code></pre>
                </div>`;
      } catch (__) {
        // 忽略错误，使用默认渲染
      }
    }
    return `<pre class="hljs"><code>${md.utils.escapeHtml(str)}</code></pre>`;
  },
});

// md.use(markdownItEcharts, { echarts });
md.use(mkatex);

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    Footer,
  },
  data() {
    return {
      currentIndex: 0, // 当前屏幕索引
      isScrolling: false, // 是否正在滚动中
      isScattered: false, // 碎片是否散开
      sections: 2, // 总屏幕数量
      photoRotation: 0, // 照片墙当前旋转角度
      photoRotationStep: 0, // 照片墙当前旋转步进
      photoList: [
        { id: 1, src: require('@/assets/img/home/rang1.png'), content: '自动化完成组织碳盘查全流程，满足企业合规申报与内部低碳管理', title: '碳盘查 AI Agent' },
        { id: 2, src: require('@/assets/img/home/rang2.png'), content: '提供园区零碳创建全流程专业服务', title: '零碳园区 AI Agent' },
        { id: 3, src: require('@/assets/img/home/rang3.png'), content: '面向工业企业及园区，提供能耗监测、碳核算与能效优化的智能管理服务', title: '能碳平台 AI Agent' },
        { id: 4, src: require('@/assets/img/home/rang4.png'), content: '内嵌欧盟 CBAM 细则，自动核算隐含碳排放并生成合规申报报告', title: 'CBMA AI Agent' },
        { id: 5, src: require('@/assets/img/home/rang5.png'), content: '智能管理碳资产全生命周期，助力企业合规履约与价值提升', title: '碳资产 AI Agent' },
        { id: 6, src: require('@/assets/img/home/rang6.png'), content: '整合政策标准与案例研究，提供权威系统的碳管理知识支持', title: '双碳知识库 AI Agent' },
        { id: 7, src: require('@/assets/img/home/rang7.png'), content: '依托自研垂类大模型，助力企业高效精准低成本完成碳排放核算与报告生成', title: '碳足迹 AI Agent' },
        { id: 8, src: require('@/assets/img/home/rang8.png'), content: '提供绿色项目评估与融资全流程支持，助力企业合规办理绿色信贷', title: '绿色金融评估认证 AI Agent' },
        { id: 9, src: require('@/assets/img/home/rang9.png'), content: '面向政府及园区主体，提供低碳零碳试点申报创建验收全流程专业支持', title: '低碳零碳 AI Agent' },
        { id: 10, src: require('@/assets/img/home/rang10.png'), content: '打造全流程编制闭环，助力企业低成本完成高质量 ESG 信息披露', title: 'ESG 报告 AI Agent' },
        // { id: 11, src: require('@/assets/img/home/rang11.png'), alt: 'Photo 11', content: '碳知，以 AI 重构双碳工作的时代级产品', title: '碳知' },
        // { id: 12, src: require('@/assets/img/home/rang12.png'), alt: 'Photo 12', content: '碳知，以 AI 重构双碳工作的时代级产品', title: '碳知' },
      ],
      transitionDuration: 1500, // 过渡动画时间（毫秒），这里改为1秒
      newMessage: "",
      carouselIndex: 0, // 轮播当前索引
      carouselInterval: null, // 轮播定时器
      isSection3Scrolling: false, // 第三屏内部是否正在滚动
      section3ScrollPosition: 0, // 第三屏内部滚动位置
      isPhotoWheelLocked: false, // 第三屏照片轮盘滚轮锁
      photoWheelAccumulatedDelta: 0, // 触摸板滚动累加值
      photoWheelLastDirection: 0, // 触摸板滚动方向
      photoWheelLastTime: 0, // 上次翻页时间
      carouselData: [
        {
          title: "碳芯",
          subtitle: "垂类专业大模型",
          infoList: [
            "• ≧15万条 联合国/国家/行业/地方排放因子库",
            "• ≧700亿条 海量模型参数",  
            "• ≧8万条 中碳独家人工高精度精修语料",
            "• 覆盖范围一/二/三",
            // "• >65%专业能力提升（与通用大模型相比）"
          ]
        },
        {
          title: "碳知",
          subtitle: "面向下一代的行业生态AI平台",
          infoList: [
            "• 双碳从业者的工具包",
            "• 双碳管理者的知识库",  
            // "• 100% 可追溯、可审计的逻辑链路",
            // "• 覆盖范围一、二、三 全场景碳核算",
            // "• 显著优于 通用大模型的权威性与严谨性"
          ]
        },
        {
          title: "碳行",
          subtitle: "全球首个碳中和领域AI Agent平台",
          infoList: [
            "• 自动编写代码采集数据",
            "• 模型自动规划工作流程",  
            "• AI自主匹配排放因子",
            "• 个性化输出报告",
            // "• 将方案落地为可持续扩展的双碳服务网络"
          ]
        }
      ],
      chatMessages: [
        {
          type: 'bot',
          content: '您好！我是碳中枢AI助手，很高兴为您服务。请问有什么可以帮助您的吗？',
          timestamp: new Date()
        }
      ],
      isChatScrolling: false,
      isTyping: false, // 是否正在输入中
      eventSource: null, // 新增 EventSource 实例变量
      fullResponse: "", // 用于存储完整的回复内容
      controller: null, // 用于控制响应的 AbortController
      conversationId: "",
      requestData: {
        inputs: {
          language: "zh-CN",
        },
        query: "",
        response_mode: "streaming",
        conversation_id: "",
        user: "",
        files: []
      },
      messages: [],
      isChatExpanded: false, // 控制聊天框是否展开
      showTips: false,
      carbonWords: [
        "CO₂e 12,840 t",
        "Scope 1 384.2 tCO₂e",
        "Scope 2 9,248 tCO₂e",
        "PAS 2060",
        "Scope 3 42,016 tCO₂e",
        "Net Zero 2060",
        "Carbon Neutral Pathway",
        "GHG Protocol",
        "ISO 14064",
        "ISO 14067",
        "碳盘查数据",
        "产品碳足迹",
        "组织边界确认",
        "运营边界确认",
        "排放因子匹配",
        "活动数据采集",
        "用电量 84,200 kWh",
        "天然气 12,540 m³",
        "柴油 9,420 L",
        "汽油 4,806 L",
        "绿电占比 36.8%",
        "可再生能源证书",
        "I-REC 2,000 MWh",
        "CCER 1,200 t",
        "碳信用抵消",
        "碳资产管理",
        "双碳目标拆解",
        "减排路径模拟",
        "节能率 18.6%",
        "碳强度下降 42%",
        "单位产值排放",
        "供应链排放",
        "运输排放 682 t",
        "冷媒泄漏 23.4 kg",
        "甲烷 CH₄",
        "氧化亚氮 N₂O",
        "电力排放因子",
        "区域电网因子",
        "碳数据校验",
        "异常值识别",
        "AI Carbon Agent",
        "MRV Measurement",
        "Reporting",
        "Verification",
        "ESG Disclosure",
        "TCFD",
        "ISSB S2",
        "CDP Climate",
        "SBTi Target",
        "1.5°C Pathway",
        "低碳工厂",
        "零碳园区",
        "碳中和实验室",
        "光伏发电 8.7 MW",
        "风电 3.2 MW",
        "储能系统 2.4 MWh",
        "雨水回收 62%",
        "余热回收",
        "建筑能耗监测",
        "BEMS",
        "智慧能源调度",
        "碳排放预测",
        "边界清单",
        "数据溯源",
        "核算口径",
        "LCA 生命周期",
        "Cradle to Gate",
        "Cradle to Grave",
        "Ecoinvent",
        "EF Database",
        "绿色供应链",
        "低碳运输",
        "绿色金融",
        "碳交易价格",
        "ETS Allowance",
        "碳配额履约",
        "减排量核证",
        "基准线情景",
        "项目边界",
        "额外性论证",
        "碳汇监测",
        "森林碳汇",
        "蓝碳生态",
        "碳捕集 CCUS",
        "Direct Air Capture",
        "Biochar",
        "Energy Efficiency",
        "Clean Energy",
        "Carbon Ledger",
        "碳中和目标",
        "碳达峰",
        "碳足迹核算",
        "碳强度指标",
        "减排潜力",
        "碳预算",
        "碳中和路线图",
        "净零排放",
        "碳中和认证",
        "碳中和标签",
        "绿色采购",
        "低碳出行",
        "新能源汽车",
        "电动汽车充电",
        "碳普惠",
        "个人碳账户",
        "碳积分",
        "绿色消费",
        "节能改造",
        "余压利用",
        "能源管理系统",
        "EMS",
        "智能电表",
        "能耗监测",
        "碳排放权",
        "碳抵消",
        "VCS",
        "GS",
        "CDM",
        "碳核查认证",
        "第三方核查",
        "碳中和声明",
        "科学碳目标",
        "Net Zero Commitment",
        "Carbon Neutral 2025",
        "零碳工厂认证",
        "绿色建筑认证",
        "LEED",
        "BREEAM",
        "绿色工厂",
        "清洁生产",
        "循环经济",
        "资源循环利用",
        "废弃物回收",
        "碳减排技术",
        "氢能利用",
        "核能",
        "地热能",
        "潮汐能",
        "生物质能",
        "碳中和基金",
        "ESG投资",
        "绿色债券",
        "碳保险",
        "碳金融衍生品"
      ],
      section3ScrollProgress: 0, // 第三屏滚动进度 0-1
      section3AnimationProgress: 0, // 第三屏中间区域动画进度 0-1（由wheel事件驱动，与scrollTop解耦）
      isSection3Entered: false, // 是否已经进入第三屏
      isSection3MiddleAnimationDone: false, // 中间区域动画是否已完成
      section3WheelLock: false, // 第三屏滚轮节流锁
      carbonWordText: '碳中和之路', // 中间文字
      showText: false, // 是否显示散乱的文字
    };
  },
  computed: {
    visiblePhotos() {
      const total = this.photoList.length;
      const visibleCount = 5;
      const centerStep = ((this.photoRotationStep % total) + total) % total;
      const centerIndex = centerStep;
      const photos = [];
      const half = Math.floor(visibleCount / 2);

      for (let offset = -half; offset <= half; offset++) {
        const index = (centerIndex + offset + total) % total;
        photos.push({
          ...this.photoList[index],
          itemIndex: index,
          slotIndex: offset + half,
        });
      }
      return photos;
    },
    centerPhoto() {
      const total = this.photoList.length;
      const centerIndex = ((this.photoRotationStep % total) + total) % total;
      return this.photoList[centerIndex];
    }
  },
  mounted() {
    // // 启动轮播自动播放
    // this.startCarousel();
    // 添加触摸板支持
    this.addTrackpadSupport();
    // 监听屏幕切换，只有进入第三屏时才添加滚动监听
    this.$watch('currentIndex', (newIndex) => {
      if (newIndex === 1) {
        this.$nextTick(() => {
          this.addSection3ScrollListener();
          // 标记进入第三屏，开始显示散乱的文字
          this.isSection3Entered = true;
          // 重置滚动进度为0（散乱状态）
          this.section3ScrollProgress = 0;
          this.section3AnimationProgress = 0;
          this.isSection3MiddleAnimationDone = false;
        });
      } else {
        this.removeSection3ScrollListener();
        // 离开第三屏，重置状态
        this.isSection3Entered = false;
        this.section3ScrollProgress = 0;
        this.section3AnimationProgress = 0;
        this.isSection3MiddleAnimationDone = false;
      }
    });
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    // this.stopCarousel();
    // 移除触摸板支持
    this.removeTrackpadSupport();
    // 移除第三屏滚动监听
    this.removeSection3ScrollListener();
  },
  methods: {
    gotoWeb() {
      this.gotoWebSite()
    },
    handleSpecialViewScroll(e) {
      const carouselEl = this.$el?.querySelector('.photo-carousel');
      if (!carouselEl) return;

      const rect = carouselEl.getBoundingClientRect();
      const x = e.clientX;
      const y = e.clientY;
      const isInside = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      if (!isInside) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const now = performance.now();
      const direction = e.deltaY > 0 ? 1 : -1;
      const deltaModeFactor = e.deltaMode === 1 ? 40 : e.deltaMode === 2 ? 800 : 1;
      const normalizedDelta = Math.abs(e.deltaY) * deltaModeFactor;

      if (this.photoWheelLastDirection !== direction) {
        this.photoWheelAccumulatedDelta = 0;
        this.photoWheelLastDirection = direction;
      }
      this.photoWheelAccumulatedDelta += normalizedDelta;

      const threshold = 180;
      const minInterval = 180;
      if (this.photoWheelAccumulatedDelta < threshold || now - this.photoWheelLastTime < minInterval) {
        return;
      }

      this.photoWheelAccumulatedDelta = 0;
      this.photoWheelLastTime = now;

      if (this.isPhotoWheelLocked) {
        return;
      }
      this.isPhotoWheelLocked = true;
      const unlockDelay = 180;
      setTimeout(() => {
        this.isPhotoWheelLocked = false;
      }, unlockDelay);

      const total = this.photoList.length;
      this.photoRotationStep = ((this.photoRotationStep + direction) % total + total) % total;
      const visibleCount = 5;
      const angleStep = 144 / (visibleCount - 1);
      this.photoRotation = this.photoRotationStep * angleStep;
    },
    
    getPhotoClass(index) {
      const visibleCount = this.visiblePhotos.length;
      const centerIndex = (visibleCount - 1) / 2;
      const distanceFromCenter = Math.abs(index - centerIndex);
      if (distanceFromCenter === 0) return 'is-center';
      if (distanceFromCenter === 1) return 'is-near';
      return 'is-edge';
    },

    selectPhoto(photoId) {
      const targetIndex = this.photoList.findIndex((item) => item.id === photoId);
      if (targetIndex === -1) return;
      this.photoRotationStep = ((targetIndex % this.photoList.length) + this.photoList.length) % this.photoList.length;
      const visibleCount = 5;
      const angleStep = 144 / (visibleCount - 1);
      this.photoRotation = this.photoRotationStep * angleStep;
    },

    getPhotoStyle(index) {
      const visibleCount = this.visiblePhotos.length;
      const centerIndex = (visibleCount - 1) / 2;
      const angles = [-72, -36, 0, 36, 72];
      const angle = angles[index] ?? 0;
      let x = 0;
      let y = 0;

      const carouselEl = this.$el?.querySelector('.photo-carousel');
      const carouselWidth = carouselEl?.clientWidth || window.innerWidth || 1356;
      const radius = Math.min(680, carouselWidth * 0.5);
      const offsetY = 30;

      // 统一使用角度计算位置，保持外观一致（边缘、近边和中心都由角度决定）
      const radian = (angle * Math.PI) / 180;
      x = radius * Math.sin(radian);
      y = radius * (1 - Math.cos(radian)) - offsetY;

      // 对最左/最右两个边缘位置使用固定坐标，确保边缘 X/Y 精准匹配视觉设计。
      if (index === 0) {
        x = -520;
        y = 380;
      } else if (index === visibleCount - 1) {
        x = 520;
        y = 380;
      }

      // 对靠近中心的两个位置（slot 1 和 slot visibleCount-2）使用更紧凑的 X/Y 值，
      // 保持视觉上更贴近设计（与之前的 -300/300, 47 类似，但按 radius 缩放）。
      const nearX = Math.min(320, Math.round(radius * 0.52));
      const nearY = Math.max(100, Math.round(radius * 0.07));
      if (index === 1) {
        x = -nearX;
        y = nearY;
      } else if (index === visibleCount - 2) {
        x = nearX;
        y = nearY;
      }

      const opacity = index === 0 || index === visibleCount - 1 ? 0.9 : 1;
      const zIndex = visibleCount - Math.abs(index - centerIndex);

      return {
        transform: `translate(calc(100vw * ${x} / 1920), calc(100vh * ${y} / 1080)) rotate(${angle}deg)`,
        zIndex,
        opacity,
      };
    },
    
    gotoWeb() {
      this.gotoWebSite()
    },
    /**
     * 添加触摸板支持
     */
    addTrackpadSupport() {
      // 监听触摸板手势
      document.addEventListener('wheel', this.handleWheel, { passive: false });
    },
    
    /**
     * 移除触摸板支持
     */
    removeTrackpadSupport() {
      document.removeEventListener('wheel', this.handleWheel);
    },
    /**
     * 处理鼠标滚轮和触摸板事件
     */
    handleWheel(e) {
      // 如果正在滚动中，则忽略后续滚轮事件
      if (this.isScrolling) return;

      // 如果聊天容器正在滚动，忽略全屏滚动
      if (this.isChatScrolling) return;

      // 如果在第三屏，优先处理内部滚动
      if (this.currentIndex === 1) {
        this.handleSection3Scroll(e);
        return;
      }

      // 对于非第三屏，阻止默认行为并处理全屏切换
      e.preventDefault();

      // 全屏切换逻辑
      if (e.deltaY > 0) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    },

    /**
     * 处理第三屏内部滚动
     */
    handleSection3Scroll(e) {
      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const container = section3Container;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      const scrollHeight = container.scrollHeight;

      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;

      // 如果中间区域动画未完成，阻止实际滚动，用wheel事件驱动动画
      if (!this.isSection3MiddleAnimationDone) {
        e.preventDefault();
        e.stopPropagation();

        if (isScrollingDown) {
          // 向下滚动：推进动画进度，限制最大增量防止滚轮过快跳过动画
          const rawIncrement = Math.abs(e.deltaY) / 800;
          const progressIncrement = Math.min(rawIncrement, 0.16);
          this.section3AnimationProgress = Math.min(1, this.section3AnimationProgress + progressIncrement);

          // 一旦词组已经完成倒三角排布，立即放行页面滚动
          if (this.section3AnimationProgress >= 0.08) {
            this.isSection3MiddleAnimationDone = true;
            this.section3ScrollProgress = 1;
          }
        } else {
          // 向上滚动：如果已经在顶部，切换到上一屏；否则可以回退动画进度
          if (scrollTop <= 10) {
            this.prevSection();
          } else {
            const rawDecrement = Math.abs(e.deltaY) / 800;
            const progressDecrement = Math.min(rawDecrement, 0.08);
            this.section3AnimationProgress = Math.max(0, this.section3AnimationProgress - progressDecrement);
          }
        }

        // 动画过程中同步更新中间文字
        if (this.section3AnimationProgress > 0.01) {
          this.carbonWordText = '碳中和之路，从未如此清晰';
          this.showText = true;
        } else {
          this.carbonWordText = '碳中和之路';
          this.showText = false;
        }

        return;
      }

      // 检查是否在边界（使用更大的容差）
      const isAtTop = scrollTop <= 10;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;

      // 如果不在边界，允许自然滚动（不阻止默认行为）
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
          // 不阻止默认行为，让浏览器处理自然滚动
        return;
      }

      // 如果已完成中间动画，且在顶部向上滚动，则优先反转到散开状态，避免误触上一屏切换
      if (!isScrollingDown && isAtTop && this.isSection3MiddleAnimationDone) {
        e.preventDefault();
        e.stopPropagation();

        const rawDecrement = Math.abs(e.deltaY) / 800;
        const progressDecrement = Math.min(rawDecrement, 0.08);
        this.section3AnimationProgress = Math.max(0, this.section3AnimationProgress - progressDecrement);

        if (this.section3AnimationProgress <= 0) {
          this.section3AnimationProgress = 0;
          this.isSection3MiddleAnimationDone = false;
          this.carbonWordText = '碳中和之路';
          this.showText = false;
        } else {
          this.carbonWordText = '碳中和之路，从未如此清晰';
          this.showText = true;
        }
        return;
      }

      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();

      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 添加第三屏滚动监听
     */
    addSection3ScrollListener() {
      const section3Container = document.querySelector('.section-3-container');
      if (section3Container) {
        section3Container.addEventListener('scroll', this.onSection3Scroll);
      }
    },

    /**
     * 移除第三屏滚动监听
     */
    removeSection3ScrollListener() {
      const section3Container = document.querySelector('.section-3-container');
      if (section3Container) {
        section3Container.removeEventListener('scroll', this.onSection3Scroll);
      }
    },

    /**
     * 处理第三屏滚动事件
     */
    onSection3Scroll() {
      // 只有在当前屏幕是第三屏时才处理
      if (this.currentIndex !== 1) return;

      const section3Container = document.querySelector('.section-3-container');
      if (!section3Container) return;
      const scrollTop = section3Container.scrollTop;
      const clientHeight = section3Container.clientHeight;
      const scrollHeight = section3Container.scrollHeight;

      // 计算滚动进度（只在前半部分区域生效）
      const maxScroll = (scrollHeight - clientHeight) * 0.6;
      this.section3ScrollProgress = Math.min(scrollTop / maxScroll, 1);

      // 如果中间动画已完成，使用scrollTop驱动；否则使用animationProgress
      const effectiveProgress = this.isSection3MiddleAnimationDone
        ? this.section3ScrollProgress
        : this.section3AnimationProgress;

      // // 根据滚动进度更新中间文字
      // if (effectiveProgress > 0.01) {
      //   this.carbonWordText = '碳中和之路，从未如此清晰';
      // } else {
      //   this.carbonWordText = '碳中和之路';
      // }
    },

    /**
     * 获取词语的样式
     */
    getWordStyle(index) {
      const totalWords = this.carbonWords.length;

      // 随机种子生成函数
      const random = (seed) => {
        const x = Math.sin(seed * 9999) * 10000;
        return x - Math.floor(x);
      };

      // 获取屏幕尺寸，确保大屏幕也能填满
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const container = this.$el?.querySelector('.section-3-content_middle');
      const containerWidth = container?.clientWidth || screenWidth;
      const containerHeight = container?.clientHeight || screenHeight;

      // 初始状态：杂乱无章随机分布在整个区域
      const startX = (random(index) - 0.5) * screenWidth * 1.2;
      const startY = (random(index + 100) - 0.5) * screenHeight * 1.2;
      const startSize = 12 + random(index + 200) * 14;
      const startOpacity = 0.5 + random(index + 300) * 0.3;
      const startBlur = `${(random(index + 800) * 2.2).toFixed(2)}px`;

      // 目标漏斗位置：固定35行
      const totalRows = 35;
      const topCols = Math.ceil(totalWords / totalRows);
      const rowIndex = Math.floor(index / topCols);
      const colIndex = index % topCols;
      const lastRowIndex = Math.max(0, Math.ceil(totalWords / topCols) - 1);
      const isLastRow = rowIndex === lastRowIndex;

      // 计算当前行的列数（漏斗形状：越往下越窄，顶部更宽）
      const rowProgress = rowIndex / (totalRows - 1);
      const rowShapeFactor = Math.max(0.35, 1 - rowProgress * 0.88);
      const rowVariance = Math.round((random(index + 400) - 0.5) * 2);
      const currentRowCols = isLastRow
        ? 1
        : Math.max(2, Math.min(topCols, Math.round(topCols * rowShapeFactor) + rowVariance));
      const adjustedColIndex = index - rowIndex * topCols;
      const actualColIndex = isLastRow ? 0 : Math.min(adjustedColIndex % currentRowCols, currentRowCols - 1);

      // 漏斗位置计算（像素）
      // 第一行宽度为容器宽度的78%，之后逐渐收缩形成漏斗
      const firstRowWidth = containerWidth * 0.78;
      const minSpacing = 40;
      const startSpacing = firstRowWidth / (currentRowCols + 1);
      // 从第二行开始逐渐收缩
      const shrinkFactor = rowIndex === 0 ? 1 : 1 - (1 - minSpacing / startSpacing) * Math.pow((rowIndex - 1) / (totalRows - 2), 0.7);
      const colSpacing = rowIndex === 0 ? startSpacing : startSpacing * shrinkFactor;
      // 漏斗形状内的基础位置
      const baseX = (actualColIndex - (currentRowCols - 1) / 2) * colSpacing;
      const topPadding = -350;
      const bottomPadding = 24;
      const availableHeight = Math.max(containerHeight - topPadding - bottomPadding, 1);
      const rowGap = Math.max(16, availableHeight / Math.max(totalRows - 1, 1));
      const baseY = topPadding + rowIndex * rowGap;
      // 以整体倒三角为骨架，但每个字都保留随机抖动，避免看起来过于规整
      const randomOffsetX = (random(index + 500) - 0.5) * colSpacing * 0.8;
      const randomOffsetY = (random(index + 600) - 0.5) * Math.max(8, rowGap * 0.45);
      const maxHorizontalOffset = Math.max(20, containerWidth / 2 - 80);
      const targetX = Math.max(-maxHorizontalOffset, Math.min(maxHorizontalOffset, baseX + randomOffsetX));
      const targetY = Math.max(topPadding, Math.min(containerHeight - bottomPadding, baseY + randomOffsetY));
      const targetSize = Math.max(14, 24 - rowIndex * 1.5 + (random(index + 700) - 0.5) * 2);
      const targetOpacity = 1;

      // 滚轮滚一下就直接变最后形状：只要有进度就直接显示最终状态
      const isDone = this.isSection3Entered && (this.isSection3MiddleAnimationDone || this.section3AnimationProgress > 0);

      const x = isDone ? targetX : startX;
      const y = isDone ? targetY : startY;
      const fontSize = isDone ? targetSize : startSize;
      const opacity = isDone ? targetOpacity : startOpacity;
      const filter = isDone ? 'blur(0px)' : `blur(${startBlur})`;

      return {
        transform: `translate(${x}px, ${y}px)`,
        fontSize: `${fontSize}px`,
        opacity: opacity,
        filter,
        transition: 'all 0.6s cubic-bezier(0.25, 1, 0.5, 1)',
      };
    },

    /**
     * 滚动到下一屏
     */
    nextSection() {
      if (this.currentIndex < this.sections - 1) {
        this.startScroll(this.currentIndex + 1);
      }
    },

    /**
     * 滚动到上一屏
     */
    prevSection() {
      if (this.currentIndex > 0) {
        this.startScroll(this.currentIndex - 1);
      }
    },

    /**
     * 处理聊天容器滚动
     */
    handleChatScroll(e) {
      const chatContainer = this.$refs.chatMessagesContainer;
      if (!chatContainer) return;

      const scrollTop = chatContainer.scrollTop;
      const clientHeight = chatContainer.clientHeight;
      const scrollHeight = chatContainer.scrollHeight;
      
      // 计算滚动方向
      const isScrollingDown = e.deltaY > 0;
      
      // 检查是否在边界（使用容差）
      const isAtTop = scrollTop <= 5;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
      
      // 如果不在边界，允许聊天容器自然滚动
      if ((isScrollingDown && !isAtBottom) || (!isScrollingDown && !isAtTop)) {
        // 不阻止默认行为，让聊天容器处理自然滚动
        this.isChatScrolling = true;
        return;
      }
      
      // 如果在边界，阻止默认行为并处理全屏切换
      e.preventDefault();
      e.stopPropagation();
      
      if ((isScrollingDown && isAtBottom) || (!isScrollingDown && isAtTop)) {
        this.isChatScrolling = false;
        if (isScrollingDown) {
          this.nextSection();
        } else {
          this.prevSection();
        }
      }
    },

    /**
     * 开始滚动动画
     */
    startScroll(index) {
        this.isScrolling = true;
        this.currentIndex = index;
        
        // 滚动动画结束后重置状态
        setTimeout(() => {
            this.isScrolling = false;
        }, this.transitionDuration);
    },

    // 处理键盘松开事件
    handleKeyUp(event) {
      if(this.isResponding) return; // 如果正在响应，则不处理键盘事件
      if (event.shiftKey && event.key === "Enter") {
        // Shift+Enter 换行
        return;
      }
      if (event.key === "Enter") {
        this.sendMessage(false); // 单独按 Enter
      }
    },
    
    // 处理键盘按下事件
    handleKeyDown(event) {
      // 如果按下Enter但没有按Shift，阻止默认换行行为
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
      }
    },

    closeChat(){
      const chatElement = this.$el.querySelector('.bottom_chat');
      if (chatElement && chatElement.contains(event.target)) {
        return;
      }
      
      this.isChatExpanded = false;
      this.scrollToBottom();
    },

    // 发送消息
    sendMessage(keepTrailingLineBreaks = true) {
      if (!this.newMessage.trim() || this.isResponding) return;
      
      // 动态改变聊天框尺寸
      // this.expandChat();

      const message = keepTrailingLineBreaks 
        ? this.newMessage 
        : this.newMessage.replace(/\n+$/, ''); // 去除末尾的换行符，保留中间的换行符         
      const userMsg = {
        content: message,
        isUser: true,
        isTyping: false,
        files: this.requestData.files,
      };
      this.newMessage = "";
      this.lastUserMessage = message;
      this.messages.push(userMsg);
      this.scrollToBottom();
      this.getAIResponse();
    },

    // 展开聊天框
    expandChat() {
      this.$nextTick(() => {
        this.isChatExpanded = true;
        
        // 强制重新渲染，确保样式生效
        this.$forceUpdate();
        
        // 添加延迟，确保样式完全应用
        setTimeout(() => {
          // 滚动到底部
          this.scrollToBottom();
          this.focusInput();
        }, 50);
      });
    },

    focusInput() {
      const inputElement = this.$el.querySelector('.el-textarea_view textarea');
      if (inputElement) {
        inputElement.focus();
      }
    },

    // 确保获取有效的 token
    async ensureToken() {
      let storeToken = localStorage.getItem("token");
      if (!storeToken) {
        try {
          const response = await guestLogin();
          const { token } = response.data.data;
          this.user_id = response.data.data.user_id;
          this.requestData.user = this.user_id;
          storeToken = token;
          localStorage.setItem("token", token);
          localStorage.setItem("user_id", this.user_id);
        } catch (error) {
          this.messages.pop(); // 删除加载效果消息
          // this.messages.push({
          //   content: "获取token失败，请刷新页面重试",
          //   isUser: false,
          //   isTyping: false,
          //   isLoading: false,
          // });
          throw error;
        }
      }
      return storeToken;
    },

    // 获取AI回复
    async getAIResponse() {
      this.requestData.query = this.lastUserMessage;
      this.conversation_id = this.conversationId;
      try {
        const token = await this.ensureToken();
        this.requestData.user = localStorage.getItem("user_id");
        this.requestData.access_type = "ai";
        let aiMsg = {
          content: "",
          displayText: "",
          isUser: false,
          isTyping: true,
          isLoading: true,
        };
        
        if(this.messages.length > 0 && this.messages[this.messages.length - 1].isLoading){
          this.messages.pop(); // 删除上一个消息
        }
        
        this.messages.push(aiMsg);
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const baseURL = http.defaults.baseURL;
        const url = `${baseURL}/pack/chatMessages`;        

        await fetchEventSource(url, {
          method: "POST",
          signal: signal,
          reconnect: false, // 不自动重连
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "accept-language": "zh-CN"
          },
          body: JSON.stringify(this.requestData),
          openWhenHidden: true,
          onmessage: (event) => {
            const data = JSON.parse(event.data);
            this.conversationId = data.conversation_id || this.conversationId;        
            if (data.event === "done") {
              this.$nextTick(() => {
                const formattedResponse = this.formatMessage(this.fullResponse);
                aiMsg.displayText = formattedResponse;
                aiMsg.isLoading = false;
                this.messages[this.messages.length - 1] = aiMsg;
              });
              return;
            } else if (data.event === "error") {
              this.messages.push({
                content: "222",
                isUser: false,
                isTyping: false,
                isLoading: false,
              });
              this.isResponding = false;
              this.scrollToBottom();
              return;
            }
            if (data.event.trim() === "" || data.event === "ping") return;
            if (data.answer) {
              this.fullResponse += data.answer;
              const formattedResponse = this.formatMessage(this.fullResponse);
              aiMsg.displayText = formattedResponse;
              aiMsg.isLoading = false;
              this.messages[this.messages.length - 1] = aiMsg;
              this.scrollToBottom();
            }
          },
          onclose: () => {
            this.isResponding = false;
          },
          onerror: (error) => {
            this.messages.push({
              content: "",
              isUser: false,
              isTyping: false,
              isLoading: false,
            });
            this.isResponding = false;
            this.scrollToBottom();
            throw error; // 处理错误
          },
          onopen: async (response) => {
            if (response.status == 401) {
              // 清除旧的token
              localStorage.removeItem("token");
              localStorage.removeItem("user_id");
              this.getAIResponse()
              // this.messages.push({
              //   content: "请重新提交",
              //   isUser: false,
              //   isTyping: false,
              //   isLoading: false,
              // });
              this.isResponding = false;
              // handleLogout();
            }
          },
        })
      } catch (error) {
        if(error == "TypeError: network error"){
          // this.stopResponse();
        }
        this.messages.push({
          content: "",
          isUser: false,
          isTyping: false,
          isLoading: false,
        });
      }
    },

    // 格式化消息内容
    formatMessage(text) {
      if (!text) return "";

      // 自定义链接渲染规则
      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const token = tokens[idx];
        const hrefIndex = token.attrIndex("href");
        if (hrefIndex >= 0) {
          const href = token.attrs[hrefIndex][1];
          const hasTarget = this.checkUrlContainsPath(href, 'ai_open_file');
          if (hasTarget) {
            //假设fileId是会话id，用于后期传参
            const fileId = href.split('/').pop();
            // const buttonHtml = `<button class="excel-view-btn" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</button>`;
            const buttonHtml = `<span class="span-link" data-file-id="${fileId}" onclick="window.openExcelViewer('${fileId}')">${tokens[idx + 1].content}</span>`;

            // 2. 标记当前链接为特殊链接
            token.attrSet('is-special-link', 'true');

            // 3. 清空后续文本token内容（原始URL）
            if (tokens[idx + 1] && tokens[idx + 1].type === 'text') {
              tokens[idx + 1].content = ''; // 关键：清除URL文本
            }

            return buttonHtml;
          } else {
            token.attrSet("target", "_blank");
            token.attrSet("rel", "noopener noreferrer");
          }
        }
        return self.renderToken(tokens, idx, options);
      };

      md.renderer.rules.link_close = (tokens, idx, options, env, self) => {
        // 获取对应打开标签token（link_close在link_open后2个位置）
        const linkOpenToken = tokens[idx - 2];
        if (linkOpenToken && linkOpenToken.attrGet('is-special-link') === 'true') {
          return ''; // 特殊链接不渲染闭合标签
        }
        return self.renderToken(tokens, idx, options); // 普通链接正常渲染
      };

      // 自定义数学公式渲染规则
      const renderMath = (content, displayMode) => {
        try {
          return katex.renderToString(content, { displayMode });
        } catch (error) {
          return displayMode ? `$$${content}$$` : `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-行内公式
      md.renderer.rules.math_inline = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: false });
        } catch (error) {
          return `$${content}$`;
        }
      };

      // 自定义数学公式渲染规则-块级
      md.renderer.rules.math_block = function (tokens, idx) {
        const content = tokens[idx].content;
        try {
          return katex.renderToString(content, { displayMode: true });
        } catch (error) {
          return `$$${content}$$`;
        }
      };

      // 渲染数学公式
      text = text.replace(/\\\[/g, "$$").replace(/\\\]/g, "$$"); // 替换 \[ 和 \] 为 $$
      text = text.replace(/\\\(/g, '$').replace(/\\\)/g, '$') // 替换 \( 和 \) 为 $
      text = text
        .replace(/\$\$([\s\S]*?)\$\$/g, (_, formula) =>
          renderMath(formula, true)
        )
        .replace(/\$([^$]*?)\$/g, (_, formula) => renderMath(formula, false));

      // 如果\n后面紧跟数字, 转换为 \n 1
      text = text.replace(/\n(\d+)/g, "\n $1 ");

      // 渲染 ECharts 图表
      // text = text.replace(/```echarts([\s\S]*?)```/g, (_, option) => {
      //   const containerId = `echarts-${Math.random()
      //     .toString(36)
      //     .substr(2, 9)}`;
      //   setTimeout(() => {
      //     const container = document.getElementById(containerId);
      //     console.log("是否获取到container", container)
      //     if (container) {
      //       const chart = echarts.init(container);
      //       chart.setOption(JSON.parse(option));
      //     }
      //   });
      //   return `<div id="${containerId}" class="echarts-container"></div>`;
      // }, 100);

      return md.render(text);
    },

    // 滚动到对话底部
    scrollToBottom() {
      // if (this.$refs.chatMessagesContainer) {
      //   const container = this.$refs.chatMessagesContainer;
      //   container.scrollTop = container.scrollHeight;
      // }
      this.$nextTick(() => {
        const container = this.$refs.chatMessagesContainer;
        if (container?.scrollHeight) {
          this.$nextTick(() => {
            container.scrollTop = container.scrollHeight;
          });
        }
      });
    },

    // 轮播相关方法
    // startCarousel() {
    //   this.carouselInterval = setInterval(() => {
    //     this.nextCarouselSlide();
    //   }, 5000); // 每5秒自动切换
    // },

    // stopCarousel() {
    //   if (this.carouselInterval) {
    //     clearInterval(this.carouselInterval);
    //     this.carouselInterval = null;
    //   }
    // },

    // nextCarouselSlide() {
    //   this.carouselIndex = (this.carouselIndex + 1) % this.carouselData.length;
    // },

    // goToCarouselSlide(index) {
    //   this.carouselIndex = index;
    //   // 点击指示器时重置定时器
    //   this.stopCarousel();
    //   this.startCarousel();
    // },

    gotAboutUs() {
      this.$router.push('/about');
    }
  }
};
</script>

<style lang="scss" scoped>
.fullpage-container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fullpage-wrapper {
  width: 100%;
  height: 100%;
  transition: transform 1.5s ease-in-out;
  will-change: transform;
}

.fullpage-section {
  width: 100%;
  height: 100vh;
}

.section-content {
 position: relative;
 width: 100%;
 height: 100%;
}

.topBT{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 360 / 1080);
  position: absolute;
  top: calc(100% * 83 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.topBTWorld{
  width: calc(100% * 1674 / 1920);
  height: calc(100% * 253 / 1080);
  position: absolute;
  top: calc(100% * 160 / 1080);
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 2;
}

.topBigCenter{
  width: 787px;
  max-height: calc(100vh - 225px);
  position: absolute;
  top: 160px;
  left: 488px;
  z-index: 3;
  object-fit: contain;
  // overflow: hidden;
  // clip-path: inset(0 0 50px 0);
  transition: all 0.5s cubic-bezier(0.34, 1.02, 0.64, 1); /* 使用弹性缓动函数 */
  transform-origin: center bottom; /* 设置变换原点为底部中心 */

  &:hover:not(.chat-expanded) {
    transform: scale(1.01) translateY(-10px);
  }

  /* 鼠标移出时的反向动画 */
  .topBigCenter:not(:hover):not(.chat-expanded) {
    animation: bounceDown 0.4s cubic-bezier(0.34, 1.02, 0.64, 1) forwards;
  }

  @keyframes bounceDown {
    0% {
      transform: scale(1.01) translateY(-10px);
    }
    30% {
      transform: scale(0.95) translateY(5px); /* 反向过冲 */
    }
    60% {
      transform: scale(1.02) translateY(-2px); /* 回弹 */
    }
    100% {
      transform: scale(1) translateY(0); /* 恢复原状 */
    }
  }
}

.text_1_view{
  width: 100%;
  height: 360px;
  position: absolute;
  bottom: 0px;
  left: 0;
  overflow: hidden;
  z-index: 4;
  background: linear-gradient(180deg, rgba(115, 163, 183, 0) 0%, #47789E 100%);
}

.text_1_view::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  mask-image: linear-gradient(180deg, rgba(115, 163, 183, 0) 0%, #47789E 100%),
linear-gradient(180deg, rgba(115, 163, 183, 0) 0%, #113E61 100%);
  -webkit-mask-image: linear-gradient(180deg, rgba(115, 163, 183, 0) 0%, #47789E 100%),
linear-gradient(180deg, rgba(115, 163, 183, 0) 0%, #113E61 100%);
}

.tips_1{
  width: calc(100% * 435 / 1920);
  height: calc(100% * 110 / 1080);
  position: absolute;
  top: calc(100% * 500 / 1080);
  left: calc(100% * 372 / 1920);
  z-index: 2;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;

  .tips_1_text{
    font-size: 14px;
    color:#fff;
    font-weight: 300;
    line-height: 20px;
    width: calc(100vw * 376 / 1920);
    height: calc(100vh * 85 / 1080);

    span{
      font-size: 24px;
      font-weight: 700;
    }
  }
}

.tips_2{
  width: calc(100vw * 485 / 1920);
  height: calc(100% * 80 / 1080);
  position: absolute;
  top: calc(100% * 404 / 1080);
  right: calc(100% * 411 / 1920);
  z-index: 2;
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;

  .tips_2_text{
    font-size: 14px;
    color:#fff;
    font-weight: 300;
    line-height: 20px;
    width: calc(100vw * 395 / 1920);
    height: calc(100vh * 44 / 1080);

    span{
      font-size: 24px;
      font-weight: 700;
    }
  }
}

.section-1_bottom{
  height: calc(100% * 415 / 1080);
  left: 50px;
  bottom: calc(100% * 25 / 1080);
  width: calc(100% - 100px);
  position: absolute;
  z-index: 5;

  .bottom_left_view{
    width: calc(100vw * 526 / 1920);
    // height: 196px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    animation: fadeInLeft 0.5s ease-out 0.5s both;

    .bottom_left_view_title{
      font-size: 48px;
      font-weight: 400;
      color: #fff;
      line-height: 100%;
      margin-bottom: calc(100% * 35 / 1080);
    }

    .bottom_left_view_text{
      font-size: 20px;
      color: rgba(255, 255, 255, 0.75);
      line-height: 150%;
      font-weight: 300;
    }

    .bottom_left_view_img{
      width: 275px;
      height: 30px;
      margin-top:30px;
      object-fit: contain;
    }
  }

  // 添加动画定义
  @keyframes fadeInUpChat {
    0% {
      opacity: 0;
      transform: translateX(-51.1%) translateY(100px);
    }
    100% {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  .bottom_chat{
    width: calc(100vw * 620 / 1920);
    height: calc(100vh * 200 / 1080);
    background: rgba(217, 217, 217, 0.45);
    border-radius: 20px;
    position: absolute;
    bottom: 0px;
    left:50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeInUpChat 0.5s ease-out 0s both;

    &.bottom_chat_expanded {
      width: calc(100vw * 707 / 1920);
      height: calc(100vh * 455 / 1080);
      left:51.1%;
      transform: translateX(-51.1%) scale(1) !important;
      opacity: 1;
      border: none;
      animation: none;
    }

    .bottom_chat_view{
      width: calc(100vw * 600 / 1920);
      height: calc(100vh * 170 / 1080);
      border-radius: 20px;
      border: 2px solid rgba(255, 255, 255, 1);
      backdrop-filter: blur(1px);
      box-shadow: 0px 25px 50px 0px rgba(0, 0, 0, 0.75);
      background: rgba(255, 255, 255, 0.65);
      background-image: url('../assets/img/home/bottom_chat_view_img.png');
      background-size: 100%;
      background-repeat: no-repeat;
      position: relative;

      &.bottom_chat_view_expanded {
        width: calc(100vw * 707 / 1920);
        height: calc(100vh * 455 / 1080);
        background-image: url('../assets/img/home/bottom_chat_view_img_big.png')!important;

        .bottom_chat_view_t{
          height: calc(100vh * 325 / 1080)!important;
        }

        // .bottom_chat_bar{
        //   width:100%!important;
        //   height: 40px!important;
        // }
      }

      .bottom_chat_bar{
        width:100%;
        height: 40px;
        display: flex;
        justify-content: space-between;

        .bottom_chat_bar_l{
          width: 150px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .bottom_chat_bar_l_img{
            width: 100px;
            height: 20px;
          }
        }

        .bottom_chat_bar_r{
          height: 100%;
          display: flex;
          align-items: center;
          padding-right: 20px;
          font-size: 16px;
          font-weight: 300;
          color: rgba(64, 64, 64, 1);
        }
      }

      .bottom_chat_view_t{
        width: 100%;
        height: calc(100vh * 65 / 1080);
        display: flex;
        justify-content: center;

        .bottom_chat_view_t_chat{
          margin:5px 18px 0;
          width: calc(100% - 36px);
          height: calc(100% - 21px);
          
          .chat-messages-container {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            scroll-behavior: smooth;
            padding-top:5px;
            padding-right: 5px;
            color: rgba(62, 101, 122, 1);
            overscroll-behavior: contain; /* 防止滚动传播到父容器 */
            
            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
              width: 4px;
            }
            
            &::-webkit-scrollbar-track {
              background: rgba(255, 255, 255, 0.1);
              border-radius: 2px;
            }
            
            &::-webkit-scrollbar-thumb {
              background: rgba(255, 255, 255, 0.5);
              border-radius: 2px;
              
              &:hover {
                background: rgba(255, 255, 255, 0.7);
              }
            }
            
            .chat-message {
              margin: 12px 0;
              
              &.user-message {
                display: flex;
                justify-content: flex-end;

                .message-icons {
                  display: flex;
                  align-items: center;
                  
                  .message-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin: 0 4px;
                  }
                  
                  .message-content {
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 1.4;
                    color: rgba(62, 101, 122, 0.8);
                  }
                }
              }
              
              &.bot-message {
                display: flex;
                justify-content: flex-start;
                
                .message-icons {
                  display: flex;
                  // align-items: center;
                  
                  .message-icon {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    object-fit: cover;
                    margin: 0 4px;
                  }
                  
                  .message-content {
                    color: #2d3748;
                    border-radius: 18px 18px 18px 4px;
                    font-size: 18px;
                    font-weight: 400;
                    line-height: 1.4;
                    color: rgba(62, 101, 122, 1);
                  }
                }
              }

              .typing-indicator {
                display: flex;
                align-items: center;
                padding: 8px 12px;
                
                span {
                  height: 6px;
                  width: 6px;
                  border-radius: 50%;
                  margin: 0 2px;
                  animation: typing 1.4s infinite ease-in-out;
                  
                  &:nth-child(1) { animation-delay: 0s; }
                  &:nth-child(2) { animation-delay: 0.2s; }
                  &:nth-child(3) { animation-delay: 0.4s; }
                }

                @keyframes typing {
                  0%, 60%, 100% {
                    transform: translateY(0);
                    opacity: 0.4;
                  }
                  30% {
                    transform: translateY(-5px);
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }

      .bottom_chat_view_b{
        width: 97%;
        height: 40px;
        margin-bottom: 5px;
        margin-left:9px;
        display: flex;
        border-radius: 10px;
        align-items: center;
        justify-content: center;
        background: rgba(240, 240, 240, 0.3);
        backdrop-filter: blur(15px);
        border: 1px solid;
        border-image-source: conic-gradient(from 102.21deg at 52.75% 38.75%, rgba(249, 249, 249, 0.5) -32.95deg, rgba(64, 64, 64, 0.5) 10.52deg, rgba(64, 64, 64, 0.35) 32.12deg, #FFFFFF 60.28deg, rgba(255, 255, 255, 0.5) 107.79deg, rgba(64, 64, 64, 0.35) 187.59deg, #F9F9F9 207.58deg, #FFFFFF 287.31deg, rgba(249, 249, 249, 0.5) 327.05deg, rgba(64, 64, 64, 0.5) 370.52deg);

        ::v-deep .el-textarea__inner{
          background: rgba(255, 255, 255, 0.75) !important;
          border: none!important;
          color: rgba(127, 127, 127, 1);
          resize: none;
          width: 100%;
          height: 100%;
          border-radius: 100px;
        }

        .el-textarea_view{
            color: rgba(127, 127, 127, 1);
            font-size: 18px;
            font-weight: 400;
            border: none!important;
            border-radius: 100px;
            background: rgba(255, 255, 255, 0.75) !important;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
        }

        ::v-deep .el-textarea__inner::placeholder {
            color: rgba(127, 127, 127, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /* 谷歌 */
        ::v-deep .el-textarea__inner::-webkit-input-placeholder {
            color: rgba(127, 127, 127, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /* 火狐 */
        ::v-deep .el-textarea__inner:-moz-placeholder {
            color: rgba(127, 127, 127, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }
            /*ie*/
        ::v-deep .el-textarea__inner:-ms-input-placeholder {
            color: rgba(127, 127, 127, 1);
            font-size: 18px;
            font-weight: 400;
            letter-spacing: 2px;
            resize: none;
            width: 100%;
            height: 100%;
        }

        .bottom_chat_send{
          width:50px;
          height: 34px;
          background: rgba(79, 114, 142, 1);
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 1px;
          right: 8px;
          cursor: pointer;

          .bottom_chat_send_icon{
            width: 18px;
            height: 16px;
          }
        }
      }
    }
  }

  .bottom_right_view{
    width: calc(100vw * 433 / 1920);
    height: calc(100vh * 414 / 1080);
    border-radius: 24px;
    backdrop-filter: blur(4px);
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 0px 22px 0px rgba(242, 242, 242, 0.5) inset;
    box-shadow: 0px 0px 0px 1px rgba(153, 153, 153, 1) inset;
    box-shadow: -2px -2px 1px -2px rgba(179, 179, 179, 1) inset;
    box-shadow: 2px 2px 1px -2px rgba(179, 179, 179, 1) inset;
    box-shadow: 3px 3px 0.5px -3.5px rgba(255, 255, 255, 0.5) inset;
    position: absolute;
    bottom: 0px;
    right:0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    animation: fadeInRight 0.5s ease-out 0.5s both;

    .bottom_right_view_img{
      width: calc(100vw * 310 / 1920);
      height: calc(100vh * 138 / 1080);
      margin: calc(100vh * 15 / 1080) auto calc(100vh * 5 / 1080);
    }

    .bottom_right_view_view{
      width: calc(100vw * 405 / 1920);
      height:calc(100vh - calc(100vh * 174 / 1080));
      position: relative;
      
      ::v-deep .el-carousel__container{
        border-radius: 20px;
        width: calc(100vw * 405 / 1920);
        height: calc(100vh * 211 / 1080);
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      }
      
      ::v-deep .el-carousel__item{
        border-radius: 20px;
        width: calc(100vw * 405 / 1920);
        height: calc(100vh * 211 / 1080);
      }

      ::v-deep .el-carousel__indicator.el-carousel__indicator--horizontal .el-carousel__button {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 0.5)!important;
        border-radius: 50%;
      }

      ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
        width: 10px;
        height: 10px;
        background: rgba(255, 255, 255, 1)!important;
        border-radius: 50%;
      }
      
      .bottom_right_view_view_v{
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        width: 100%;
        height: calc(100vh * 220 / 1080);
        border: 1px solid rgba(255, 255, 255, 0.2);
        display: flex;
        flex-direction: column;

        .bottom_right_view_view_v_title{
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          line-height: 24px;
          letter-spacing: 5px;
          margin: calc(100vh * 15 / 1080) auto 0;

          span{
            letter-spacing: 0px;
          }
        }

        .bottom_right_view_view_v_title_other{
          font-size: 16px;
          font-weight: 300;
          color: #fff;
          margin: calc(100vh * 5 / 1080) auto calc(100vh * 10 / 1080);
        }

        .bottom_right_view_view_v_info{
          margin: 0 43px;
          font-size: 14px;
          font-weight: 300;
          line-height: 21px;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
      }
    }
  }
}

.textRight{
  right: 0;
  position: absolute;
}

.textRight_1{
  right: 340px;
  position: absolute;
}

.text_1{
  font-size: 64px;
  font-weight: 700;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  letter-spacing: -5px;
  color: #fff;
}

.circle {
  width: 613px;
  height: 613px;
  border-radius: 50%;
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.top_1_img{
  width: 100vw;
  height: 100px;
  position: absolute;
  left: 0;
  top: 705px;
}

/* 各屏背景色 */
.section-1 {
  /* background: linear-gradient(180deg, rgba(1, 240, 155, 0.2) 0%, rgba(1, 140, 255, 0.6) 79.03%); */
  background: url(../assets/img/home/back_1.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  .section-content_1{
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
    width: 100%;
    height: 100%;
  }

  .topBack{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.section-3 {
  height: 100vh;
  position: relative;
  overflow: hidden;

  .section-3-container {
    width: 100%;
    height: 100vh;
    transition: all 0.3s ease;
    overflow-y: auto;
    overflow-x: hidden;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    min-height: 100vh;

    &.scrollable {
      overflow-y: auto!important;
      overflow-x: hidden;
      height: 100vh;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .section-3-content {
      min-height: 100vh;
      overflow-x: hidden;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      position: relative;
    }

    .section-3-content_middle{
      width: 100%;
      height: 100vh;
      display: block;
      position: relative;
      overflow: hidden;
      background: linear-gradient(180deg, #4B9DBB 0%, #FFFFFF 100%);
      // background: linear-gradient(180deg, #000000 0%, #406581 50.48%, #FFFFFF 100%);
      // background: linear-gradient(180deg, #FFFFFF 1.5%, #F5F5F7 7.69%);
    }

    .carbon-word {
      position: absolute;
      left: 50%;
      top: 50%;
      font-weight: 500;
      color: #fff;
      white-space: nowrap;
      pointer-events: none;
      text-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      margin-left: -50px;
      margin-top: -10px;
    }

    .carbonWordText{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-weight: 700;
      font-size: 48px;
      color: #ffffff;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }

    .carbonWordText_1{
      position: absolute;
      left: 50%;
      top: 55%;
      transform: translateX(-50%);
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.65);
    }

    .carbonWordText_2{
      position: absolute;
      left: 50%;
      top: 60%;
      transform: translateX(-50%);
      font-weight: 500;
      font-size: 18px;
      color: rgba(41, 142, 255, 1);
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      cursor: pointer;
    }

    .section-3-content_bottom{
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.5s ease, visibility 0.5s ease;

      &.visible {
        opacity: 1;
        visibility: visible;
      }

      .img1{
        width: 362px;
        height: 375px;
      }

      .bottom_view{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 28px;

        .img2{
          width: 298px;
          height: 135px;
          margin-bottom: 38px;
        }

        .bottom_view_title{
          font-weight: 700;
          font-style: Bold;
          font-size: 48px;
          line-height: 100%;
          text-align: center;
          color:rgba(0, 0, 0, 1);
        }

        .bottom_view_subtitle{
          font-weight: 500;
          font-size: 18px;
          line-height: 100%;
          text-align: center;
          color: rgba(127, 127, 127, 1);
        }

        .bottom_view_button{
          font-weight: 500;
          font-size: 18px;
          line-height: 100%;
          text-align: center;
          color: rgba(41, 142, 255, 1);
          cursor: pointer;
        }
      }

      .bottom_view_gsap{
        height: calc(100vh * 505 / 1080);
      }

      .mt-175{
        margin-top: calc(100vh * 175 / 1080);
      }

      .special_view {
        width: 100%;
        height: 540px;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .photo-carousel {
        position: relative;
        width: 100%;
        height: 300px;
        display: flex;
        justify-content: center;
        // align-items: center;
        transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        will-change: transform;
      }

      .photo-carousel_info {
        position: relative;
        z-index: 10;
        text-align: center;
        color: #fff;
        transition: opacity 0.3s ease;

        .photo-carousel_info-title {
          font-size: 18px;
          margin-bottom: 8px;
          color: rgba(0, 0, 0, 1);
        }

        .photo-carousel_info-content {
          font-size: 18px;
          color: rgba(127, 127, 127, 1);
          font-weight: 400;
          line-height: 1.6;
        }
      }

      .photo-item {
        position: absolute;
        width: clamp(140px, calc(100vw * 160 / 1920), 220px);
        height: clamp(210px, calc(100vw * 220 / 1920), 280px);
        border-radius: 24px;
        transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        transform-origin: center center;
        will-change: transform, opacity;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 24px;
          transition: box-shadow 0.6s cubic-bezier(0.25, 1, 0.5, 1), transform 0.6s cubic-bezier(0.25, 1, 0.5, 1);
        }
      }

      .photo-item.is-center img {
        filter: brightness(1);
      }

      .photo-item.is-near img {
        filter: brightness(0.92);
      }

      .photo-item.is-edge img {
        filter: brightness(0.82);
      }

      .photo-left, .photo-right {
        clip-path: inset(0 50% 0 0);
      }

      .photo-far-left, .photo-far-right {
        clip-path: inset(0 0 0 50%);
      }

      .container {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .piece {
        position: absolute;
        background: #000000;
        transform: translate(0, 0) rotate(0deg) scale(1);
      }
      /* 匹配原图8块碎片形状 */
      .p1 {
        width: 360px;
        height: 42px;
        clip-path: polygon(0 100%, 100% 0, 82% 100%);
        border-radius: 6px;
      }
      .p2 {
        width: 320px;
        height: 76px;
        clip-path: polygon(0 100%, 100% 72%, 88% 0, 8% 36%);
        border-radius: 6px;
      }
      .p3 {
        width: 96px;
        height: 54px;
        border-radius: 12px;
      }
      .p4 {
        width: 170px;
        height: 48px;
        clip-path: polygon(0 28%, 88% 0, 100% 100%, 8% 76%);
        border-radius: 6px;
      }
      .p5 {
        width: 230px;
        height: 38px;
        clip-path: polygon(4% 18%, 100% 0, 90% 100%, 0 66%);
        border-radius: 6px;
      }
      .p6 {
        width: 210px;
        height: 34px;
        clip-path: polygon(6% 14%, 100% 0, 94% 100%, 0 62%);
        border-radius: 6px;
      }
      .p7 {
        width: 150px;
        height: 210px;
        clip-path: polygon(8% 0, 100% 18%, 82% 100%, 0 76%);
        border-radius: 6px;
      }
      .p8 {
        width: 190px;
        height: 230px;
        clip-path: polygon(0 0, 88% 8%, 100% 100%, 4% 82%);
        border-radius: 6px;
      }
    }
  }
}
</style>